import { useMst } from "@store/Route";
import { observer } from "mobx-react-lite";
import React, { useEffect, useRef, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import logo from "../../img/ui/kaye-logo.png";
import worldAmericanAcademyLogo from "../../img/ui/world-american-academy.png";
import menuIcon from "../../img/icons/menu.png";

import "./Header.scss";
import { useOutsideAlerter } from "@utils/demenstion";

type SomeComponentProps = RouteComponentProps;

const Header: React.FC<SomeComponentProps> = observer(({ location }) => {
  const { reset, landing } = useMst();
  const locationPath = location.pathname.split("/")[1];
  const locationPathActive = location.pathname.split("/")[2];

  const [isWorldAmericanAcademy, setIsWorldAmericanAcademy] = useState(false);

  const [show, setShow] = useState(false);
  const ref = useRef(null);
  useOutsideAlerter(ref, () => setShow(false));

  useEffect(() => {
    const url = window.location.href;
    if (
      url.includes("xwa.lingweitpt") ||
      url.includes("xcl.lingweitpt") ||
      url.includes("xaa.lingweitpt")
    ) {
      setIsWorldAmericanAcademy(true);
    }
  }, []);

  return (
    <header
      className={locationPath !== "dashboard" ? "Header__second" : "Header"}
    >
      {locationPath !== "dashboard" ? (
        <Link
          to={
            location.pathname.split("/")[1] === "dashboard" ? "/dashboard" : "/"
          }
        >
          {/* <img className="no-select" src={logo} width="157" height="46" /> */}
        </Link>
      ) : (
        <div ref={ref} className={`topnav ${show ? "responsive" : ""}`}>
          <Link
            to={
              location.pathname.split("/")[1] === "dashboard"
                ? "/dashboard"
                : "/"
            }
            onClick={() => setShow(!show)}
          >
            {isWorldAmericanAcademy ? (
              <img
                className="no-select"
                src={worldAmericanAcademyLogo}
                width="160"
                height="90"
              />
            ) : (
              <img className="no-select" src={logo} width="90" height="46" />
            )}
          </Link>
          <div className="navWrapper">
            <Link
              className={`navtext ${
                locationPathActive === "schedule" ? "active" : ""
              }`}
              to={"/dashboard/schedule"}
              onClick={() => setShow(!show)}
            >
              Schedule
            </Link>
            {/* Disable Temporary */}
            <Link
              className={`navtext ${
                locationPathActive === "payment" ? "active" : ""
              }`}
              to={"/dashboard/payment"}
              onClick={() => setShow(!show)}
            >
              Payment
            </Link>
            <Link
              className={`navtext ${
                locationPathActive === "manage" ? "active" : ""
              }`}
              to={"/dashboard/manage"}
              onClick={() => setShow(!show)}
            >
              Manage
            </Link>
            <Link
              to={""}
              className={`navtext`}
              onClick={() => {
                reset();
                landing.deleteToken();
                setShow(!show);
              }}
            >
              Logout
            </Link>
          </div>
          <div
            className="icon"
            onClick={() => {
              setShow(!show);
            }}
          >
            <img src={menuIcon} className="iconmenu" />
          </div>
        </div>
      )}
    </header>
  );
});

export default withRouter(Header);
